// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"b1d387d9","769":"8ed0dbe9"}[chunkId] + ".chunk.css";
};